// /* eslint-disable import/first */
import React from 'react'
import {
  FileText,
  Layout,
  List as ListIcons,
  Monitor,
  Settings,
  UploadCloud,
  Sliders,
  User,
  Users
} from 'react-feather'
// All pages that rely on 3rd party components (other than Material-UI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size
// Guards
import { AuthGuard } from '../components/tsComponents/AuthGuard'
import Application from '../pages/application/Application'
import Modules from '../pages/application/Modules'
import Page404 from '../pages/auth/Page404'
import Page500 from '../pages/auth/Page500'
import ResetPassword from '../pages/auth/ResetPassword'
// Auth components
import SignIn from '../pages/auth/SignIn'
import SignUp from '../pages/auth/SignUp'
import { AllBusiness } from '../pages/business/Business'
import CreateBusiness from '../pages/business/CreateBusiness'
import ContactPerson from '../pages/contact_person/ContactPerson'
import KitchenCounter from '../pages/counters/KitchenCounters'
import Customer from '../pages/customer/Customer'
import PayPerUserPlan from '../pages/host/PayPerUserPlan'
import PayPerUserPurchaseOrderType from '../pages/host/PayPerUserPurchaseOrderType'
import KitchenOrder from '../pages/kot/KitchenOrder'
import Items from '../pages/menu_items/Items'
import Purchase from '../pages/purchase/Purchase'
import PurchaseOrder from '../pages/purchase/PurchaseOrder'
import Orders from '../pages/subscriptions/Orders'
import Subscription from '../pages/subscriptions/Subscription'
import Tables from '../pages/tables/Table'
import TerminalHeaderFooter from '../pages/terminal/TerminalHeaderFooter'
import Terminal from '../pages/terminal/Terminals'
import TerminalOffline from '../pages/terminal/offline/TerminalsOffline'

import TerminalSettings from '../pages/terminal/TerminalSettings'
import UserProfile from '../pages/user/UserProfile'
import { ListAllUsers, ListUsers } from '../pages/user/Users'
import Vendors from '../pages/vendors/Vendors'
import Waiter from '../pages/waiter/Waiter'
import Default from '../pages/dashboards/Default'
import { HostTerminalOfflineCreate } from '../pages/terminal/offline/HostTerminalOffline'
import LedgerEntry from '../pages/ledger/ledgerEntry'
import bulkUpload from '../pages/bulkUpload/bulkUpload'
import Inventory from '../pages/menu_items/inventory'
import BillwiseReport from '../pages/reports/billwiseReport'
import DeleteBillReport from '../pages/reports/deletedBillReport'
import DaywiseReport from '../pages/reports/daywiseReport'
import ItemwiseReport from '../pages/reports/itemWiseReport'
import InventoryReport from '../pages/reports/inventoryReport'
import Units from '../pages/menu_items/units'
import UserwiseReport from '../pages/reports/userwiseReport'
import CounterwiseReport from '../pages/reports/counterwiseReport'
import WriteOffReport from '../pages/reports/writeOffReport'
import DuplicateBillReport from '../pages/reports/duplicateBillReport'
import AppFlavour from '../pages/host/AppFlavour'
import PaymentwiseReport from '../pages/reports/paymentwiseReport'
import PaymentMethod from '../pages/payment_method/payment_method'
import Franchise from '../pages/franchise/franchise'
import { Devices, Store } from '@mui/icons-material'
import FranchiseUsers from '../pages/franchise/franchiseUsers'
import OutletwiseSummaryReport from '../pages/reports/outletwiseSummaryReport'
import FranchisewiseSummaryReport from '../pages/reports/franchisewiseSummaryReport'
import WaiterSalesReport from '../pages/reports/WaiterSalesReport'
import WaiterItemWiseReport from '../pages/reports/WaiterItemWiseReport'
import WaiterCommissionReport from '../pages/reports/WaiterCommissionReport'
import WaiterMonthWiseReport from '../pages/reports/WaiterMonthWiseReport'
const dashboardsRoutes = {
  id: 'Dashboard',
  // path: '/dashboard',
  // header: "Pages",
  icon: <Sliders />,
  path: '/dashboard/default',
  containsHome: true,
  children: null,
  component: Default,
  guard: AuthGuard
}

const UserProfileRoutes = {
  id: 'User',
  path: '/user/profile',
  // header: "Pages",
  containsHome: true,
  children: null,
  component: UserProfile,
  guard: AuthGuard
}

const ListAllUsersRoutes = {
  id: 'AllUsers',
  path: '/all/users',
  // header: "Pages",
  icon: <Users />,
  containsHome: true,
  children: null,
  component: ListAllUsers,
  guard: AuthGuard
}

const ListAllBusinessRoutes = {
  id: 'All Business',
  path: '/all/Business',
  // header: "Pages",
  icon: <Layout />,
  containsHome: true,
  children: null,
  component: AllBusiness,
  guard: AuthGuard
}

const CreateBusinessRoutes = {
  id: 'Business',
  path: '/business/create',
  // header: "Pages",
  containsHome: true,
  children: null,
  component: CreateBusiness,
  guard: AuthGuard
}

const ownerReportRoutes = {
  id: 'Reports',
  path: '/reports',
  icon: <FileText />,
  children: [
    {
      path: '/reports/billwise',
      name: 'Billwise',
      component: BillwiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/daywise',
      name: 'Daywise',
      component: DaywiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/outlet/summary',
      name: 'Outletwise Summary',
      component: OutletwiseSummaryReport,
      guard: AuthGuard
    },
    {
      path: '/reports/franchise/summary',
      name: 'Franchise Summary',
      component: FranchisewiseSummaryReport,
      guard: AuthGuard
    },
    {
      path: '/reports/itemwise',
      name: 'Itemwise',
      component: ItemwiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/waiter/sales',
      name: 'Waiter Sales',
      component: WaiterSalesReport,
      guard: AuthGuard
    },
    {
      path: '/reports/waiter/itemwise',
      name: 'Waiter Item-Wise',
      component: WaiterItemWiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/waiter/commission',
      name: 'Waiter Commission',
      component: WaiterCommissionReport,
      guard: AuthGuard
    },
    {
      path: '/reports/waiter/monthwise',
      name: 'Waiter Month-Wise',
      component: WaiterMonthWiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/deletebill',
      name: 'Deleted Bills',
      component: DeleteBillReport,
      guard: AuthGuard
    },
    {
      path: '/reports/duplicatebill',
      name: 'Duplicate Bills',
      component: DuplicateBillReport,
      guard: AuthGuard
    },
    {
      path: '/reports/inventory',
      name: 'Inventory',
      component: InventoryReport,
      guard: AuthGuard
    },
    {
      path: '/reports/writeoff',
      name: 'Write Off',
      component: WriteOffReport,
      guard: AuthGuard
    },
    {
      path: '/reports/userwise',
      name: 'Userwise',
      component: UserwiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/counterwise',
      name: 'Counterwise',
      component: CounterwiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/paymentwise',
      name: 'Paymentwise',
      component: PaymentwiseReport,
      guard: AuthGuard
    }
  ],
  component: null
}

const reportRoutes = {
  id: 'Reports',
  path: '/reports',
  icon: <FileText />,
  children: [
    {
      path: '/reports/billwise',
      name: 'Billwise',
      component: BillwiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/daywise',
      name: 'Daywise',
      component: DaywiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/summary',
      name: 'Summary',
      component: OutletwiseSummaryReport,
      guard: AuthGuard
    },
    {
      path: '/reports/itemwise',
      name: 'Itemwise',
      component: ItemwiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/waiter/sales',
      name: 'Waiter Sales',
      component: WaiterSalesReport,
      guard: AuthGuard
    },
    {
      path: '/reports/waiter/itemwise',
      name: 'Waiter Item-Wise',
      component: WaiterItemWiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/waiter/commission',
      name: 'Waiter Commission',
      component: WaiterCommissionReport,
      guard: AuthGuard
    },
    {
      path: '/reports/waiter/monthwise',
      name: 'Waiter Month-Wise',
      component: WaiterMonthWiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/deletebill',
      name: 'Deleted Bills',
      component: DeleteBillReport,
      guard: AuthGuard
    },
    {
      path: '/reports/duplicatebill',
      name: 'Duplicate Bills',
      component: DuplicateBillReport,
      guard: AuthGuard
    },
    {
      path: '/reports/inventory',
      name: 'Inventory',
      component: InventoryReport,
      guard: AuthGuard
    },
    {
      path: '/reports/writeoff',
      name: 'Write Off',
      component: WriteOffReport,
      guard: AuthGuard
    },
    {
      path: '/reports/userwise',
      name: 'Userwise',
      component: UserwiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/counterwise',
      name: 'Counterwise',
      component: CounterwiseReport,
      guard: AuthGuard
    },
    {
      path: '/reports/paymentwise',
      name: 'Paymentwise',
      component: PaymentwiseReport,
      guard: AuthGuard
    }
  ],
  component: null
}

const HostRoutes = {
  id: 'Host',
  path: '/host',
  icon: <Layout />,
  children: [
    {
      path: '/host/application',
      name: 'Applications',
      component: Application,
      guard: AuthGuard
    },
    {
      path: '/host/modules',
      name: 'Modules',
      component: Modules,
      guard: AuthGuard
    },
    {
      path: '/host/terminal',
      name: 'Terminals',
      component: HostTerminalOfflineCreate,
      guard: AuthGuard
    },
    {
      path: '/host/payperuserplans',
      name: 'Plans',
      component: PayPerUserPlan,
      guard: AuthGuard
    },
    {
      path: '/host/purchaseordertype',
      name: 'Purchase Order Type',
      component: PayPerUserPurchaseOrderType,
      guard: AuthGuard
    },
    {
      path: '/host/appFlavours',
      name: 'App Flavours',
      component: AppFlavour,
      guard: AuthGuard
    }
  ],
  component: null
}

const usersRoutes = {
  id: 'Users',
  path: '/users',
  icon: <Users />,
  children: null,
  component: ListUsers,
  guard: AuthGuard
}

const ownerUsersRoutes = {
  id: 'Users',
  path: '/users',
  icon: <Users />,
  children: [
    {
      path: '/users',
      name: 'Own Users',
      component: ListUsers,
      guard: AuthGuard
    },
    {
      path: '/users/franchise',
      name: 'Franchise',
      component: FranchiseUsers,
      guard: AuthGuard
    }
  ],
  component: null
}

const customersRoutes = {
  id: 'Customers',
  path: '/customers',
  icon: <Users />,
  children: [
    {
      path: '/customers',
      name: 'List',
      component: Customer,
      guard: AuthGuard
    },
    {
      path: '/ledgerEntry',
      name: 'Ledger Entry',
      component: LedgerEntry,
      guard: AuthGuard
    }
  ],
  component: null
}

const KOTRoutes = {
  id: 'KOT',
  path: '/KOT',
  icon: <Layout />,
  children: [
    {
      path: '/kot/byID',
      name: 'Kitchen Order',
      component: KitchenOrder,
      guard: AuthGuard
    }
  ],
  component: null
}
const vendorsRoutes = {
  id: 'Vendors',
  path: '/vendors',
  icon: <Users />,
  children: [
    {
      path: '/vendors',
      name: 'List Vendors',
      component: Vendors,
      guard: AuthGuard
    }
  ],
  component: null
}

const contactPersonRoutes = {
  id: 'ContactPerson',
  path: '/contactperson',
  icon: <Users />,
  children: [
    {
      path: '/contactperson',
      name: 'Contact Person',
      component: ContactPerson,
      guard: AuthGuard
    }
  ],
  component: null
}

const purchaseRoutes = {
  id: 'Purchase',
  path: '/purchase',
  icon: <Layout />,
  children: [
    {
      path: '/purchase',
      name: 'Purchase',
      component: Purchase,
      guard: AuthGuard
    },
    {
      path: '/purchase/purchaseorder',
      name: 'Purchase Order',
      component: PurchaseOrder,
      guard: AuthGuard
    }
  ],
  component: null
}

const TerminalRoutes = {
  id: 'Terminal',
  path: '/terminal',
  icon: <Devices />,
  children: [
    {
      path: '/terminals',
      name: 'Online',
      component: Terminal,
      guard: AuthGuard
    },
    {
      path: '/terminals/offline',
      name: 'Offline',
      component: TerminalOffline,
      guard: AuthGuard
    }
  ],
  component: null
}

const FownerTerminalRoutes = {
  id: 'Terminal',
  path: '/terminal',
  icon: <Devices />,
  children: [
    {
      path: '/terminals',
      name: 'Online',
      component: Terminal,
      guard: AuthGuard
    }
  ],
  component: null
}

const menuItemsRoutes = {
  id: 'Menu Items',
  path: '/menu_items',
  icon: <ListIcons />,
  children: [
    {
      path: '/menu_items/counters',
      name: 'Kitchen Counters',
      component: KitchenCounter,
      guard: AuthGuard
    },
    {
      path: '/menu_items/items',
      name: 'Items',
      component: Items,
      guard: AuthGuard
    },
    {
      path: '/menu_items/inventory',
      name: 'Inventory',
      component: Inventory,
      guard: AuthGuard
    },
    {
      path: '/menu_items/units',
      name: 'Units',
      component: Units,
      guard: AuthGuard
    }
  ],
  component: null
}

const bulkUploadRoutes = {
  id: 'Bulk Upload',
  path: '/bulk-upload',
  icon: <UploadCloud />,
  children: null,
  component: bulkUpload,
  guard: AuthGuard
}

const subscriptionRoutes = {
  id: 'My Account',
  path: '/myaccount',
  icon: <User />,
  children: [
    {
      path: '/myAccount/subscriptionplans',
      name: 'Subscription Plans',
      component: Subscription,
      guard: AuthGuard
    },
    {
      path: '/myAccount/currentsubscriptionplan',
      name: 'Current Plan',
      component: Orders,
      guard: AuthGuard
    }
  ],
  component: null
}

const outletRoutes = {
  id: 'Franchise',
  path: '/franchise',
  icon: <Store />,
  children: null,
  component: Franchise,
  guard: AuthGuard
}

const configurationRoutes = {
  id: 'Configuration',
  path: '/configuration',
  icon: <Settings />,
  children: [
    {
      path: '/configuration/headerfooter',
      name: 'Header Footer',
      component: TerminalHeaderFooter,
      guard: AuthGuard
    },
    {
      path: '/configuration/settings',
      name: 'Settings',
      component: TerminalSettings,
      guard: AuthGuard
    },
    {
      path: '/configuration/waiters',
      name: 'Waiters',
      component: Waiter,
      guard: AuthGuard
    },
    {
      path: '/configuration/tables',
      name: 'Tables',
      component: Tables,
      guard: AuthGuard
    },
    {
      path: '/configuration/paymentmethod',
      name: 'Payment Methods',
      component: PaymentMethod,
      guard: AuthGuard
    }
  ],
  component: null
}

const authRoutes = {
  id: 'Auth',
  path: '/auth',
  icon: <Users />,
  children: [
    {
      path: '/auth/sign-in',
      name: 'Sign In',
      component: SignIn
    },
    {
      path: '/auth/sign-up',
      name: 'Sign Up',
      component: SignUp
    },
    {
      path: '/auth/reset-password',
      name: 'Reset Password',
      component: ResetPassword
    },
    {
      path: '/auth/404',
      name: '404 Page',
      component: Page404
    },
    {
      path: '/auth/500',
      name: '500 Page',
      component: Page500
    }
  ],
  component: null
}

const landingRoutes = {
  id: 'Landing Page',
  path: '/',
  header: 'Docs',
  icon: <Monitor />,
  component: SignIn,
  children: null
}

// Routes using the Dashboard layout

export const dashboardLayoutRoutes_Owner = [
  dashboardsRoutes,
  outletRoutes,
  configurationRoutes,
  TerminalRoutes,
  ListAllUsersRoutes,
  ListAllBusinessRoutes,
  ownerUsersRoutes,
  bulkUploadRoutes,
  ownerReportRoutes,
  menuItemsRoutes,
  CreateBusinessRoutes,
  customersRoutes,
  vendorsRoutes,
  KOTRoutes,
  purchaseRoutes,
  // subscriptionRoutes,
  UserProfileRoutes,
  contactPersonRoutes
]

export const dashboardLayoutRoutes_Admin = [
  dashboardsRoutes,
  outletRoutes,
  configurationRoutes,
  TerminalRoutes,
  ListAllUsersRoutes,
  bulkUploadRoutes,
  ListAllBusinessRoutes,
  usersRoutes,
  CreateBusinessRoutes,
  reportRoutes,
  menuItemsRoutes,
  customersRoutes,
  vendorsRoutes,
  KOTRoutes,
  purchaseRoutes,
  UserProfileRoutes,
  contactPersonRoutes
]

export const dashboardLayoutRoutes_FOwner = [
  dashboardsRoutes,
  outletRoutes,
  configurationRoutes,
  FownerTerminalRoutes,
  ListAllUsersRoutes,
  bulkUploadRoutes,
  ListAllBusinessRoutes,
  usersRoutes,
  CreateBusinessRoutes,
  reportRoutes,
  menuItemsRoutes,
  customersRoutes,
  vendorsRoutes,
  KOTRoutes,
  purchaseRoutes,
  UserProfileRoutes,
  contactPersonRoutes
]

export const dashboardLayoutRoutes_HAdmin = [
  // dashboardsRoutes,
  HostRoutes,
  // ListAllUsersRoutes,
  ListAllBusinessRoutes
]

export const dashboardLayoutRoutes_User = [dashboardsRoutes]
// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes]

// Routes using the Presentation layout
export const presentationLayoutRoutes = [landingRoutes]

// Routes that are protected
export const protectedRoutes = []

// Routes visible in the sidebar

export const sidebarRoutes_Owner = [
  dashboardsRoutes,
  outletRoutes,
  configurationRoutes,
  TerminalRoutes,
  ownerUsersRoutes,
  ownerReportRoutes,
  menuItemsRoutes,
  bulkUploadRoutes,
  customersRoutes
  // vendorsRoutes,
  // contactPersonRoutes,
  // purchaseRoutes,
  // subscriptionRoutes
]

export const sidebarRoutes_Admin = [
  dashboardsRoutes,
  outletRoutes,
  configurationRoutes,
  TerminalRoutes,
  usersRoutes,
  reportRoutes,
  menuItemsRoutes,
  bulkUploadRoutes,
  customersRoutes
  // vendorsRoutes,
  // contactPersonRoutes,
  // purchaseRoutes,
]
export const sidebarRoutes_FOwner = [
  dashboardsRoutes,
  outletRoutes,
  configurationRoutes,
  FownerTerminalRoutes,
  usersRoutes,
  reportRoutes,
  menuItemsRoutes,
  bulkUploadRoutes,
  customersRoutes
]

export const sidebarRoutes_HAdmin = [
  // dashboardsRoutes,
  HostRoutes,
  // ListAllUsersRoutes,
  ListAllBusinessRoutes
]
